var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.75C7.91421 3.75 8.25 4.08579 8.25 4.5V17.6893L12.2197 13.7197C12.5126 13.4268 12.9874 13.4268 13.2803 13.7197C13.5732 14.0126 13.5732 14.4874 13.2803 14.7803L8.03033 20.0303C7.73744 20.3232 7.26256 20.3232 6.96967 20.0303L1.71967 14.7803C1.42678 14.4874 1.42678 14.0126 1.71967 13.7197C2.01256 13.4268 2.48744 13.4268 2.78033 13.7197L6.75 17.6893V4.5C6.75 4.08579 7.08579 3.75 7.5 3.75ZM15.9697 3.96967C16.2626 3.67678 16.7374 3.67678 17.0303 3.96967L22.2803 9.21967C22.5732 9.51256 22.5732 9.98744 22.2803 10.2803C21.9874 10.5732 21.5126 10.5732 21.2197 10.2803L17.25 6.31066V19.5C17.25 19.9142 16.9142 20.25 16.5 20.25C16.0858 20.25 15.75 19.9142 15.75 19.5V6.31066L11.7803 10.2803C11.4874 10.5732 11.0126 10.5732 10.7197 10.2803C10.4268 9.98744 10.4268 9.51256 10.7197 9.21967L15.9697 3.96967Z",
    fill: "#E2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.163b9d4a3ba3153c55fb14e3553ef5da.svg";
export { ForwardRef as ReactComponent };